let result;

export const getLoadMstv = () => {
  if (result) return Promise.resolve(result);
  return import('./mstv-player').then((module) => {
    result = module;
    return module;
  });
};